import { axios, baseURL } from '@/plugins/axios.js'
import { DirectUpload } from '@rails/activestorage'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchTags(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/tags', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTag(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/tags/search', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTagsList(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/tags/list', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createTag(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/tags', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateTag(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/tags/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidTag(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/tags/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAnalytics(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/tags/analytics', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    advancedSearch(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/tags/advanced_search', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    attachProduct(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/tags/${params.id}/attach`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    mergeTag(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/tags/merge', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOems(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/oems')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOemList(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/oems/list', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createOem(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/oems', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateOem(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/oems/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidOem(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/oems/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSeries(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/series', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSeriesList(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/series/list', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createSeries(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/series', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateSeries(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/series/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidSeries(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/series/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchFuels(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/fuels')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createFuel(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/fuels', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchBatteryTypes(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/battery_types')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createBatteryType(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/battery_types', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateBatteryType(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/battery_types/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchModels(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/tags/models`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeAttachedImage(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/tags/${params.id}/remove_photo`, {params})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCountries(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get("/api/v1/variables/countries")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addCountry(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/variables/add_country', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    directUploadTagPhoto(ctx, file) {
      return new Promise((resolve, reject) => {
        const url = `${baseURL}/direct_uploads?referer=tag_photo`
        const upload = new DirectUpload(file, url, {
          directUploadWillCreateBlobWithXHR: xhr => {
            const authHeaders = $cookies.get('userAuth')
            if (authHeaders) {
              xhr.setRequestHeader('access-token', authHeaders['access-token'])
              xhr.setRequestHeader('token-type', authHeaders['token-type'])
              xhr.setRequestHeader('client', authHeaders.client)
              xhr.setRequestHeader('expiry', authHeaders.expiry)
              xhr.setRequestHeader('uid', authHeaders.uid)
            }
          },
        })

        upload.create((error, blob) => {
          if (error) reject(error)
          else resolve(blob)
        })
      })
    },
  }
}